import type { PendingPreAuthorizationRequest, PreAuthorization } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchPreAuthorizations = async (storeId: number) => {
  const response = await gozokiApiWithAuth.get<PreAuthorization[]>(
    `/stores/${storeId}/pre-authorizations`,
  )
  return response.data
}

export const fetchPendingPreAuthorizationRequests = async (storeId: number) => {
  const response = await gozokiApiWithAuth.get<PendingPreAuthorizationRequest[]>(
    `/stores/${storeId}/pre-authorization-requests`,
  )
  return response.data
}
